webpackJsonp([148965310965549],{

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = HelpCopy;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HelpCopy() {
	  return _react2.default.createElement(
	    'span',
	    { className: 'display-inlineBlock', style: { maxWidth: 480 } },
	    'Something we haven\'t covered?',
	    ' ',
	    _react2.default.createElement(
	      _link2.default,
	      { type: 'blue', url: 'mailto:help@marvelapp.com', target: '_blank' },
	      'Email us'
	    ),
	    ' ',
	    'and we\'ll get back to you!'
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Terms;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _list = __webpack_require__(116);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _HeroSkinny = __webpack_require__(148);
	
	var _HeroSkinny2 = _interopRequireDefault(_HeroSkinny);
	
	var _HelpCopy = __webpack_require__(592);
	
	var _HelpCopy2 = _interopRequireDefault(_HelpCopy);
	
	var _Line = __webpack_require__(205);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Terms() {
	  var boldClasses = 'fontWeight-5 c-slate';
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: 'Terms | Marvel',
	      meta: [{ name: 'description', content: 'Terms and conditions for Marvel' }, { name: 'keywords', content: '' }],
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 'xl', position: 'bottom' },
	      _react2.default.createElement(
	        _pageWrap2.default,
	        { size: 's' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 'xl', position: 'bottom' },
	          _react2.default.createElement(_HeroSkinny2.default, { tag: 'h1', title: 'Terms of service', copy: _react2.default.createElement(_HelpCopy2.default, null) })
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 'm', position: 'bottom' },
	          _react2.default.createElement(
	            _paragraph2.default,
	            { tag: 'span', size: 'l' },
	            'Welcome to the',
	            ' ',
	            _react2.default.createElement(
	              _link2.default,
	              {
	                type: 'blue',
	                url: 'https://www.marvelapp.com/',
	                target: '_blank'
	              },
	              'MarvelApp.com'
	            ),
	            ' ',
	            'website/service which is operated by Marvel Prototyping Ltd (in this Agreement, "MarvelApp", "Marvel, "we", "us" or "our").'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 'm', position: 'bottom' },
	          _react2.default.createElement(
	            _paragraph2.default,
	            { tag: 'span' },
	            'We run a prototyping service called MarvelApp and would love for you (\u201Cyou\u201D, \u201Cyour\u201D, \u201Cuser\u201D) to use it. Our basic service is free, and we will offer more advanced features in the future. Our service is designed to give you as much control and ownership over what goes on your site as possible and encourage you to express yourself freely. However, we also encourage you to be responsible in what you publish as a project (\u201CProject\u201D) In particular, make sure that no prohibited items such as spam, viruses, hate content, pirated material, copyrighted material etc. appear on or get linked to from your site. We do not claim any intellectual property rights whatsoever in/of your files.'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 'm', position: 'bottom' },
	          _react2.default.createElement(
	            _paragraph2.default,
	            { tag: 'span' },
	            'If you find a MarvelApp project that you believe violates our terms of service, please report it to',
	            ' ',
	            _react2.default.createElement(
	              _link2.default,
	              { type: 'blue', url: 'mailto:help@marvelapp.com', target: '_blank' },
	              'help@marvelapp.com'
	            ),
	            '.'
	          )
	        ),
	        _react2.default.createElement(_Line2.default, null),
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 'm', position: 'bottom' },
	          _react2.default.createElement(
	            _paragraph2.default,
	            { tag: 'span', size: 'm', color: 'slate' },
	            'The following terms and conditions govern all use of the MarvelApp website and all content, services and products available at or through the website, iOS and Android apps unless you have a written agreement in place with us covering such use in which event the written agreement shall take priority. The Website and apps are owned and operated by Marvel Prototyping Ltd. ("Marvel"). The Website and apps are offered subject to your acceptance without modification of all of the terms and conditions contained herein and all other operating rules, policies (including, without limitation, Marvel Prototyping Ltd',
	            ' ',
	            _react2.default.createElement(
	              _link2.default,
	              { type: 'blue', url: '/privacy', target: '_blank' },
	              'Privacy Policy'
	            ),
	            ') and procedures that may be published from time to time on this Site by Marvel Prototyping Ltd (collectively, the "Agreement").'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 'm', position: 'bottom' },
	          _react2.default.createElement(
	            _paragraph2.default,
	            { tag: 'span', size: 'm', color: 'slate' },
	            'Please read this Agreement carefully before accessing or using the Website or apps. By accessing or using any part of the web site, you agree to become bound by the terms and conditions of this agreement. If you do not agree to all the terms and conditions of this agreement, then you may not access the Website, apps or use any services. If these terms and conditions are considered an offer by Marvel Prototyping Ltd, acceptance is expressly limited to these terms. The Website and apps are available only to individuals who are at least 13 years old.'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'margin', size: 'm', position: 'bottom' },
	          _react2.default.createElement(
	            _paragraph2.default,
	            { tag: 'span', size: 'm', color: 'slate' },
	            _react2.default.createElement(
	              _list2.default,
	              { type: 'ordered' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Your MarvelApp Account and Site.'
	                ),
	                ' ',
	                'If you create an account or Project on the Website or apps, you are responsible for maintaining the security of your account, and you are fully responsible for all activities that occur under the account and any other actions taken in connection with the blog. You must not add images to your Project in a misleading or unlawful manner, including in a manner intended to trade on the name or reputation of others, and marvelapp.com may change or remove any Project that it considers inappropriate or unlawful, or otherwise likely to cause marvelapp.com liability. You must immediately notify Marvel Prototyping of any unauthorized uses of your Project or your account or any other breaches of security. Marvel Prototyping will not be liable for any acts or omissions by You, including any damages of any kind incurred as a result of such acts or omissions.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Responsibility of Contributors.'
	                ),
	                ' ',
	                'If you operate a Project, account, post images to the Website or apps, or otherwise make (or allow any third party to make) material available by means of the Website or apps (any such material, "Content"), You are entirely responsible for the content of, and any harm resulting from, that Content. That is the case regardless of whether the Content in question constitutes text, graphics, an audio file, or computer software. By making Content available, you represent and warrant that:',
	                _react2.default.createElement(
	                  _spacing2.default,
	                  { type: 'margin', size: 's', position: 'top' },
	                  _react2.default.createElement(
	                    _list2.default,
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'The downloading, copying and use of the Content will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark or trade secret rights, of any third party;'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'If your employer has rights to intellectual property you create, you have either (i) received permission from your employer to post or make available the Content, including but not limited to any software, or (ii) secured from your employer a waiver as to all rights in or to the Content;'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'You have fully complied with any third-party licenses relating to the Content, and have done all things necessary to successfully pass through to end users any required terms;'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'To the extent that any Content contains personal data, you have obtained all necessary consents or are otherwise lawfully entitled to use such personal data in the Content;'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'The Content does not contain or install any viruses, worms, malware, Trojan horses or other harmful or destructive content;'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'The Content is not spam, is not machine- or randomly-generated, and does not contain unethical or unwanted commercial content designed to drive traffic to third party sites or boost the search engine rankings of third party sites, or to further unlawful acts (such as phishing) or mislead recipients as to the source of the material (such as spoofing);'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'The Content is not pornographic, does not contain threats or incite violence, and does not violate the privacy or publicity rights of any third party;'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'Your Project/account is not getting advertised via unwanted electronic messages such as spam links on newsgroups, email lists, other blogs and web sites, and similar unsolicited promotional methods; and'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'Your Project is not named in a manner that misleads your readers into thinking that you are another person or company. For example, your Project URL or name is not the name of a person other than yourself or company other than your own;'
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'If your Content contains personal data, you agree that we can process such personal data on your behalf under the terms of our',
	                      ' ',
	                      _react2.default.createElement(
	                        _link2.default,
	                        {
	                          type: 'blue',
	                          url: '/data-processing-addendum',
	                          target: '_blank'
	                        },
	                        'Data Processing Addendum'
	                      ),
	                      '.'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Marvel Prototyping acknowledges that the Content you share in your account is entirely within your control as a user. We do not claim any intellectual property rights whatsoever to your files.',
	                _react2.default.createElement(
	                  _spacing2.default,
	                  { type: 'margin', size: 's', position: 'top' },
	                  'Without limiting any of your representations or warranties, Marvel Prototyping has the right (though not the obligation) to, in Marvel\'s sole discretion (i) refuse or remove any Content that, in Marvel\'s reasonable opinion, violates any Marvel Prototyping\'s policy or is in any way harmful or objectionable, or (ii) terminate or deny access to and use of the Website or apps to any individual or entity for any reason, in Marvel\'s sole discretion. Marvel will have no obligation to provide a refund of any amounts previously paid.'
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Responsibility of Website Visitors and App Users.'
	                ),
	                ' ',
	                'Marvel Project has not reviewed, and cannot review, all of the material, including images and text, posted to the Website and apps, and cannot therefore be responsible for that material\'s content, use or effects. By operating the Website and apps, Marvel Prototyping Ltd does not represent or imply that it endorses the material there posted, or that it believes such material to be accurate, useful or non-harmful. You are responsible for taking precautions as necessary to protect yourself and your computer systems from viruses, worms, Trojan horses, and other harmful or destructive content. The Website and apps may contain content that is offensive, indecent, or otherwise objectionable, as well as content containing technical inaccuracies, typographical mistakes, and other errors. The Website and apps may also contain material that violates the privacy or publicity rights, or infringes the intellectual property and other proprietary rights, of third parties, or the downloading, copying or use of which is subject to additional terms and conditions, stated or unstated. Marvel Prototyping Ltd disclaims any responsibility for any harm resulting from the use by visitors of the Website or apps, or from any downloading by those visitors of content there posted.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Content Posted on Other Websites.'
	                ),
	                ' ',
	                'We have not reviewed, and cannot review, all of the material, including images and text, made available through the websites and webpages to which marvelapp.com links, and that link to MarvelApp. Marvel Prototyping Ltd does not have any control over those non-Marvel websites and webpages, and is not responsible for their contents or their use. By linking to a non-Marvel website or webpage, Marvel Prototyping Ltd does not represent or imply that it endorses such website or webpage. You are responsible for taking precautions as necessary to protect yourself and your computer systems from viruses, worms, Trojan horses, and other harmful or destructive content. Marvel Prototyping Ltd disclaims any responsibility for any harm resulting from your use of non-Marvel websites and webpages.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Copyright Infringement'
	                ),
	                ' As Marvel Prototyping Ltd asks others to respect its intellectual property rights, it respects the intellectual property rights of others. If you believe that material located on or linked to by marvelapp.com violates your copyright, you are encouraged to notify Marvel Prototyping Ltd. Marvel Prototyping Ltd will respond to all such notices, including as required or appropriate by removing the infringing material or disabling all links to the infringing material. Marvel Prototyping Ltd will terminate a visitor\'s access to and use of the Website and apps if, under appropriate circumstances, the visitor is determined to be a repeat infringer of the copyrights or other intellectual property rights of Marvel Prototyping Ltd or others. In the case of such termination, Marvel Prototyping Ltd will have no obligation to provide a refund of any amounts previously paid to Marvel Prototyping Ltd.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Intellectual Property.'
	                ),
	                ' ',
	                'Other than your Content, the intellectual property contained on MarvelApp website and MarvelApp, including designs and copyrightable material such as software, text, pictures, photographs and illustrations, are the property of Marvel Prototyping Ltd and its licensors. The trademarks on the MarvelApp website and MarvelApp, belong to Marvel Prototyping Ltd, its licensors or third parties. It is not allowed to place one or more of these marks and logos on your own site or to use it in any other way without the prior written consent of Marvel Prototyping Ltd, the licensor or third party in question.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Advertisements.'
	                ),
	                ' Marvel Prototyping Ltd reserves the right to display advertisements on the site.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Attribution.'
	                ),
	                ' Marvel Prototyping Ltd reserves the right to display attribution on Projects such as \u2018Powered by Marvel\'. Footer credits and the marvelapp.com toolbar may not be altered or removed.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Changes.'
	                ),
	                ' Marvel Prototyping Ltd reserves the right, at its sole discretion, to modify or replace any part of this Agreement. It is your responsibility to check this Agreement periodically for changes. Even if you do not explicitly indicate your agreement to these amended terms, your continued use of or access to the Website and apps following the posting of any changes to this Agreement constitutes acceptance of those changes. Marvel Prototyping Ltd may also, in the future, offer new services and/or features through the Website and apps (including, the release of new tools and resources). Such new features and/or services will be subject to the terms and conditions of this Agreement.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Termination.'
	                ),
	                ' Marvel Prototyping Ltd may terminate your access to all or any part of the Website and apps at any time, with or without cause, with or without notice, effective immediately. Where we terminate your paid subscription without cause, you will be eligible for a refund of your Subscription Fee with respect to the remaining days left in the month. If you wish to terminate this Agreement or your MarvelApp account (if you have one), you may simply discontinue using the Website and apps. All provisions of this Agreement which by their nature should survive termination will survive termination, including, without limitation, intellectual property provisions, warranty disclaimers, indemnity, limitations of liability, and governing law.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Disclaimer of Warranties.'
	                ),
	                ' ',
	                'The Website and apps are provided "as is". Marvel Prototyping Ltd and its suppliers and licensors hereby disclaim all warranties of any kind, express or implied, including, without limitation, the warranties of merchantability, fitness for a particular purpose and non-infringement. Neither Marvel Prototyping Ltd nor its suppliers and licensors, makes any warranty that the Website and apps will be error free or that access thereto will be continuous or uninterrupted. You understand that you download from, or otherwise obtain content or services through, the Website and apps at your own discretion and risk.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Limitation of Liability.'
	                ),
	                ' ',
	                'In no event will Marvel Prototyping Ltd, or its suppliers or licensors, be liable with respect to any subject matter of this agreement under any contract, negligence, strict liability or other legal or equitable theory for: (i) any special, incidental or consequential damages; (ii) the cost of procurement for substitute products or services; (iii) for interruption of use or loss or corruption of data; or (iv) for any amounts that exceed the fees paid by you to Marvel Prototyping Ltd under this agreement during the twelve (12) month period prior to the cause of action. Marvel Prototyping Ltd will have no liability for any failure or delay due to matters beyond their reasonable control. The foregoing will not apply to the extent prohibited by applicable law.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'General Representation and Warranty.'
	                ),
	                ' ',
	                'You represent and warrant that (i) your use of the Website and apps will be in strict accordance with the Marvel Prototyping Privacy Policy, with this Agreement and with all applicable laws and regulations (including without limitation any local laws or regulations in your country, state, city, or other governmental area, regarding online conduct and acceptable content, and including all applicable laws regarding the transmission of technical data exported from the United Kingdom or the country in which you reside) and (ii) your use of the Website and apps will not infringe or misappropriate the intellectual property rights of any third party.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Indemnification.'
	                ),
	                ' You agree to indemnify and hold harmless Marvel Prototyping Ltd, its contractors, and its licensors, and their respective directors, officers, employees and agents from and against any and all claims and expenses, including attorneys\' fees, arising out of your use of the Website and apps, including but not limited to your violation of this Agreement.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Apple, the Apple logo, iPhone, iPad, iPad Pro, Apple TV, Apple Watch and Apple Pencil are trademarks of Apple Inc., registered in the U.S. and other countries. App Store is a service mark of Apple Inc.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'User Terms.'
	                ),
	                ' As long as you pay the fees stated in the applicable subscription plan (Subscription Fees), or if you are using the free plan, you may use our design, prototyping and collaboration software (Software) as a service through the MarvelApp.com website and/or Marvel mobile application (Services) on a non-exclusive and non-transferable basis, subject to the limitations set out in these terms and in accordance with the restrictions in your applicable subscription plan (Subscription).'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'The maximum number of people allowed to use the Services is stated in your account on the MarvelApp.com website (under: My Account > Billing) and also corresponds to the number of seats purchased in your subscription plan.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Third party users can collaborate with you on any Project initiated by you using the Services as long as they access the Services for this reason only (Third Party Users). You are responsible for the rights you grant to Third Party Users and liable for their use of the Services. You must also ensure such Third Party Users agree to be subject to these terms, provided that Third Party Users will not be permitted to generate their own Projects. You can allow anyone to view your Project as long as they can\u2019t make any changes to it.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Tester Terms.'
	                ),
	                'Third Party Users may also include participant testers (Participant Testers) that have been invited to test a Project as part of the user testing feature of the Services (Testing Services). Such Participant Testers hereby agree and acknowledge that certain information including personal data may be collected pursuant to the Testing Services for the purpose of analysing their interaction with the Project, including but not limited to their email, phone number, demographic information e.g. (location/age/gender), a recording of their screen, audio and video of their face (Tester Content). Such Tester Content (and any intellectual property therein) will be deemed the Content of the user commissioning the Testing Services, who will also be deemed the data controller with respect to Tester Content comprising personal data. We will be deemed the data processor with respect to Tester Content comprising personal data. The rights of the Tester as a data subject are set out in the applicable privacy policy and our',
	                ' ',
	                _react2.default.createElement(
	                  _link2.default,
	                  {
	                    type: 'blue',
	                    url: '/data-processing-addendum',
	                    target: '_blank'
	                  },
	                  'Data Processing Addendum'
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement('a', { name: 'refund-policy' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'Refund policy and subscription terms',
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: boldClasses },
	                  'a.'
	                ),
	                ' Your Marvel subscription will auto-renew based on the billing cycle you have selected, either renewing monthly or yearly. Unless you cancel your subscription before your monthly/yearly billing date, you authorise us to charge your next month/year\'s subscription fee to your payment card/. You can find specific details regarding your Marvel subscription by visiting our website and clicking on "My Account\u201D.',
	                _react2.default.createElement(
	                  _spacing2.default,
	                  { type: 'margin', size: 's', position: 'top' },
	                  'Enterprise subscriptions auto-renew annually (unless you have purchased a multi-year subscription). You must provide 30 days written notice from your subscription end date should you wish to terminate or change your subscription. You can find more details regarding your Marvel Enterprise Subscription by contacting your designated Customer Experience Manager.'
	                ),
	                _react2.default.createElement(
	                  _spacing2.default,
	                  { type: 'margin', size: 's', position: 'top' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: boldClasses },
	                    'b.'
	                  ),
	                  ' Your Marvel Enterprise subscription will be subject to our',
	                  ' ',
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: 'https://marvelapp.com/security',
	                      target: '_blank',
	                      rel: 'noreferrer'
	                    },
	                    'Security Guidlines'
	                  ),
	                  ' ',
	                  'to keep your ideas, data and projects confidential and secure. Your Customer Experience Manager can provide you with further documentation to support you integrating Marvel. Whilst we will always endeavour to support with specific requests, should you require any custom security evaluations or documentation this may be billed separately, based on the time required for completion.'
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'You are free to cancel your Marvel subscription at any time. Payments are non-refundable and we do not provide refunds or credits for any partial-month subscription periods. To cancel, go to "My Account" and then \u201CPlans\u201D and follow the instructions for cancellation.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'We may change our subscription plans and the price of our subscriptions from time to time; however, any price changes or changes to our plans will apply to you no earlier than 30 days following notice to you. Any changes to your plan will be communicated to you 30 days in advance.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'We offer a free Team plan trial for a duration of 7 days, to allow Users to try the subscription. We will charge your card for your monthly/yearly subscription with the number of Users specified upon signing up at the end of the free trial period unless you cancel your subscription prior to the end of the free trial. To cancel, go to "My Account" and then \u201CPlans\u201D and follow the instructions for cancellation.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'If a payment error occurs on your Marvel account we will always aim to rectify this. We do not advise you file a dispute or chargeback with your card provider as as a result we will be forced to block access to your account and remove all your data for however long it takes for the bank to close your dispute.'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: boldClasses },
	                'Communication policy and terms.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Marvel needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at anytime. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, check out our',
	                ' ',
	                _react2.default.createElement(
	                  _link2.default,
	                  { type: 'blue', url: '/privacy', target: '_blank' },
	                  'Privacy Policy.'
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'We\'re proud to include content from our 3rd party providers such as Unsplash, Iconfinder and WOCinTechChat.com'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'If any of these terms are held by a court to be illegal, invalid or unenforceable, the rest of these Terms will remain in full force.'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'These terms are governed by English law and the parties agree to submit to the exclusive jurisdiction of the English Courts.'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-index-js-67e5402aba5473217aac.js